import React, { useEffect } from "react";
import URI from "urijs";
import { FormattedMessage } from "react-intl";
import { Select } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const Sorter = props => {
  const {
    handleGetDocumentsWithSearch
  } = props;
  const currentLink = useSelector(state => state.documentsWithSearch.currentLink);
  const txtSearch = useSelector(state => state.documentsWithSearch.txtSearch);
  const [sortType, setSortType] = React.useState("created_on.desc");

  useEffect(() => {
    if (!currentLink) return;
    let uri = new URI(currentLink);
    let parameter = uri.search(true);
    if (parameter.filterFromDate && parameter.filterToDate) {
      parameter.sortOnField &&
        setSortType(`${parameter.sortOnField}.${parameter.sortOrder}`);
    }
  }, [currentLink]);

  const buildOptionItem = (labelDesci18n, optionVal) => {
    return (
      <React.Fragment>
        <Option
          label={
            <div>
              {<FormattedMessage id={labelDesci18n} />}
            </div>
          }
          value={optionVal}
        >
          <FormattedMessage id={labelDesci18n} />
        </Option>
      </React.Fragment>
    );
  };

  return (
    <div style={{ marginRight: "60px" }}>
      <div style={{ marginBottom: "8px" }}>
        <FormattedMessage id={"documents.filters.typeDate.order"} />{" "}
      </div>
      <Select
        value={sortType}
        style={{ width: 256 }}
        optionLabelProp="label"
        onChange={e => {
          const filter = e.split(".");
          const field = filter[0];
          const order = filter[1];

          handleGetDocumentsWithSearch({
            link: currentLink, search: txtSearch, additionalProps: {
              sortOnField: field,
              sortOrder: order,
              page: 0
            }
          });

          setSortType(e);
        }}
      >
        {buildOptionItem("documents.filters.typeDate.createLess",
          "created_on.asc")}

        {buildOptionItem("documents.filters.typeDate.createMore",
          "created_on.desc")}

        {buildOptionItem("documents.filters.typeDate.documentLess",
          "referencing_date.asc")}

        {buildOptionItem("documents.filters.typeDate.documentMore",
          "referencing_date.desc")}

        {buildOptionItem("documents.filters.typeDate.scoreLess",
          "_score.desc")}

      </Select>
    </div>
  );
};
export default Sorter;
